import { useStore as useVuexStore } from 'vuex';

let store = null;

export function useStore(newStore) {
  store = newStore || store || useVuexStore();
  return store;
}

export function clearStore() {
  store = null;
}
